// extracted by mini-css-extract-plugin
module.exports = {"title":"section-title_title_20-lm"};